 


$(function(){
  $('.search__toggle').on('click', function(){
    $('.middle-search').addClass('open');
  });
  $('.custom-search-close').on('click', function(){
    $('.middle-search').removeClass('open');
  });

  var n = 0;
  // $(window).scroll(function() {
  //     setTimeout(function() {
  //         var e = $(window).scrollTop();
  //         n + 10 < e ? $("#nav_below").slideUp() : e < n && $("#nav_below").slideDown(), n = e
  //     }, 10);
  // });

  $('.readmore-button').on('click', function(){
    $(this).parents('.loadmore-block').find('.bottom-text').slideToggle();
    if ($(this).text() == "Load More...")
       $(this).text("Load Less...")
    else
       $(this).text("Load More...");
  });

  $('.faq-btn').on('click', function(e){
    e.preventDefault();
    $('.faq-container').slideToggle();
  });
   $('.faq-item .faq-item__title').on('click', function() {
     if($(this).parent().hasClass('open')){
       $(this).parent().find('.faq-item__description').slideUp(500);
       $(this).parent().removeClass('open');
     }else{
       $('.faq-item .faq-item__description').slideUp();
       $('.faq-item').removeClass('open');
       $(this).parent().find('.faq-item__description').slideToggle(500);
       $(this).parent().addClass('open');
     }
    });
});

 

/*var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    document.getElementById("nav_below").style.height = "41px";
  } else {
    document.getElementById("nav_below").style.height = "0px";
  }
  prevScrollpos = currentScrollPos;
}*/